import store from "@/store"
import Repository from "@/repositories/api.js"
const resource = "/admin/map_collections"

export default {
  async getAll() {
    let response = await Repository.get(resource, {
      params: { region_id: store.state.auth.chosenRegion }
    })
    return response.data.map_collections
  },
  async get(itemID) {
    let response = await Repository.get(`${resource}/${itemID}`)
    return response.data.map_collection
  },
  async create(itemData) {
    let response = await Repository.post(`${resource}`, {
      region_id: store.state.auth.chosenRegion,
      map_collection: itemData
    })
    return response.data
  },
  async update(itemID, itemData) {
    let response = await Repository.patch(`${resource}/${itemID}`, {
      map_collection: itemData
    })
    return response.data
  },
  async destroy(itemID) {
    let response = await Repository.delete(`${resource}/${itemID}`)
    return response.data
  }
}
